export default "__VITE_ASSET__Cg4ygy3H__"